import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Row, Col, Container, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { divide } from "lodash";
import Slider from "react-slick";
import classNames from "classnames";
import styled from "styled-components";
import LeftArrowSlick from "../../../images/left-slick-arrow.png"
import RightArrowSlick from "../../../images/right-slick-arrow.png"
import {
  getPopularBrands,
  getCollectionBrands,
  getCollectionProductBrands,
  getImageBanner
} from "../../../actions/kafairAction";
import { doChangeCategory } from "../../../actions/categoryAction";
import iconTitle from "../../../images/madeinindonesia.png";
import { getCloudImageUrl } from "../../../utils";

const searchCategory = id => {
  switch (id) {
    case 1:
      return "sneakers";
    case 2:
      return "apparels";
    case 9:
      return "handbags";
    case 4:
      return "lifestyles";

    default:
      return "sneakers";
  }
};

function NextArrow(props) {
  const { className, style, onClick } = props
  return (
    <StyledArrow
      className={className}
      style={{ ...style, right: "0px" }}
      onClick={onClick}
    />
  )
}

function PreviousArrow(props) {
  const { className, style, onClick } = props
  return (
    <StyledArrow
      className={className}
      style={{ ...style }}
      onClick={onClick}
    />
  )
}

const BrandItems = ({ item, onSelectBrand }) => {
  const cloudImageUrl = getCloudImageUrl(item.img_url, 150);
  return (
    <div className="brand-button" style={{ backgroundColor: "#ffffff" }}>
      {/* <span
        className="title official center"
        style={{ color: "#4a4a4a", marginTop: 0 }}
      >
        {item.name}
      </span> */}

      {item.img_url ? (
        <KickImage src={cloudImageUrl} className="img-style" />
      ) : (
        <p>{item.title ? item.title : item.name}</p>
      )}
    </div>
  );
};

class MadeInIndonesia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sneakersOpen: false,
      apparelsOpen: false,
      handbagsOpen: false,
      localOpen: false,
      page: 1,
      previewSettings: {
        arrows: true,
        autoplay: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: true,
        dots: false,
        swipe: false,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
        ],
        nextArrow: <NextArrow />,
        prevArrow: <PreviousArrow />
      }
    };
  }

  componentDidMount() {
    const payloadProducts = {
      collection: "local-brands",
      collection_type: "brands",
      page: 1,
      per_page: 16
    };

    const payloadBrands = {
      page: 1,
      per_page: 30
    };
    this.props.getImageBanner("local-brands", "local_brands");

    this.props.getCollectionProductBrands(payloadProducts, "local_brands");
    this.props.getCollectionBrands(payloadBrands, "local-brands");

  }

  navigateSearch(item) {
    const newCategory =
      item.category_name === "apparels" ? "apparel" : item.category_name;

    const brand_name = item.slug
      ? item.slug.toLowerCase().replace(/\-/g, "+")
      : "";

    this.props.doChangeCategory(item.category_name);

    this.props.history.push({
      pathname: `/search/${newCategory}/${brand_name}`,
      search: `brands=${item.id}`
    });
  }

  render() {
    const { localBrands } = this.props;
    const { data } = localBrands.brands;

    if (data.length === 0) return null;

    return (
      <Container fluid className="special-deals-section official novembazar">
        <Row
          className="content-container made-in-indonesia"
          style={{ background: `linear-gradient(345deg, rgba(255,255,255,1) 50%, rgba(141,47,59,1) 50%)`, border: "3px solid black" }}
        >
          <Col md={12} xs={12}>
            <div className="header-wrapper">
              <div style={{ position: "relative" }}>
                <KickImage alt={`${this.props.title} Category`} src={this.props.header} className="title-img" />
              </div>
              <div className="title-wrapper">
                <p></p>
              </div>
            </div>
          </Col>
          <Col md={12} xs={12} style={{ margin: "auto" }}>
            <div style={{ width: "100%" }} className="button-wrapper">
              {data &&
                data.length > 0 &&
                data.map((item, index) => {
                  const cloudImageUrl = getCloudImageUrl(item.img_url, 150);
                  return (
                    <div style={{ padding: "0px" }} className="brand-button-wrapper">
                      <div
                        className="brand-button"
                        onClick={() => this.navigateSearch(item)}
                      >
                        {item.img_url ? (
                          <div>
                            <KickImage src={cloudImageUrl} className="img-style" />
                          </div>
                        ) : (
                          <div className="title-style">
                            <span>{item.title ? item.title : item.name}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }
                )}
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

const StyledArrow = styled.div`
 &::before {
   font-size: 40px;
 }
 `

const mapStateToProps = state => ({
  data: state.dataKaFair,
  // data: state.dataKaFair.local_brands,
  localBrands: state.dataKaFair.local_brands
});

const mapDispatchToProps = dispatch => ({
  getPopularBrands: category => dispatch(getPopularBrands(category)),
  getImageBanner: (slug, name) => dispatch(getImageBanner(slug, name)),
  getCollectionProductBrands: (payload, name) =>
    dispatch(getCollectionProductBrands(payload, name)),
  getCollectionBrands: (payload, slug) =>
    dispatch(getCollectionBrands(payload, slug)),
  doChangeCategory: category => dispatch(doChangeCategory(category))
});

export default connect(mapStateToProps, mapDispatchToProps)(MadeInIndonesia);
